(function() {
    if (!window._stickyAtcHandler) {
        window._stickyAtcHandler = function() {
            if (window.innerWidth >= 768) return;
            var stickyAtcs = document.querySelectorAll('#fixed-atc');
            var originalAtcs = document.querySelectorAll('.pdp-hero .atc-form:not(#fixed-atc)');
            if (stickyAtcs.length === 0 || originalAtcs.length === 0) return;
            var stickyAtc = stickyAtcs[stickyAtcs.length - 1];
            var originalAtc = originalAtcs[originalAtcs.length - 1];
            if (!originalAtc || !stickyAtc) return;
            var rect = originalAtc.getBoundingClientRect();
            if (rect.bottom <= 0) {
                stickyAtc.classList.add('show-sticky');
            } else {
                stickyAtc.classList.remove('show-sticky');
            }
        };
        window.addEventListener('scroll', window._stickyAtcHandler, { passive: true });
        window.addEventListener('resize', window._stickyAtcHandler, { passive: true });
    }
    
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', window._stickyAtcHandler);
    } else {
        window._stickyAtcHandler();
    }

    // Presentation only: leave ProductForm, option clicks and sticky sync in main.js.
    if (!window._pdpOptionsPlacement) {
        var selector = '.pdp-hero .option-group .drawer';
        var frame;

        function placeMenu(drawer) {
            if (window.innerWidth >= 768) return;
            var label = drawer.querySelector('.label');
            var menu = drawer.querySelector('.drawer-items');
            if (!label || !menu) return;

            var viewport = window.visualViewport;
            var offsetTop = viewport ? viewport.offsetTop : 0;
            var top = offsetTop + 8;
            var height = viewport ? viewport.height : window.innerHeight;
            var bottom = offsetTop + height - 8;
            var navbar = document.getElementById('navbar');
            if (navbar) {
                var navBottom = navbar.getBoundingClientRect().bottom;
                if (navBottom > top && navBottom < bottom) top = navBottom + 8;
            }
            var rect = label.getBoundingClientRect();
            var above = Math.max(0, rect.top - top - 2);
            var below = Math.max(0, bottom - rect.bottom - 2);
            var naturalHeight = Array.prototype.reduce.call(menu.children, function(total, option) {
                return total + option.offsetHeight;
            }, 2);
            var upward = naturalHeight > below && above > below;
            var available = upward ? above : below;
            var maxHeight = Math.floor(Math.min(available, height * 0.45));

            drawer.dataset.optionsDirection = upward ? 'up' : 'down';
            drawer.dataset.optionsScrollable = String(naturalHeight > maxHeight);
            drawer.style.setProperty('--pdp-options-height', maxHeight + 'px');
            label.setAttribute('aria-expanded', String(drawer.classList.contains('open')));
        }

        function updateMenus() {
            frame = null;
            document.querySelectorAll(selector + '.open').forEach(placeMenu);
        }

        window._pdpOptionsPlacement = function() {
            if (!frame) frame = window.requestAnimationFrame(updateMenus);
        };

        function prepareMenus() {
            document.querySelectorAll(selector).forEach(placeMenu);
        }
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', prepareMenus);
        } else {
            prepareMenus();
        }

        // Capture sets geometry before the existing drawer handler opens the menu.
        document.addEventListener('click', function(event) {
            var label = event.target.closest(selector + ' > .label');
            if (!label || window.innerWidth >= 768) return;
            var drawer = label.parentElement;
            placeMenu(drawer);
            drawer.querySelector('.drawer-items').scrollTop = 0;
        }, true);

        document.addEventListener('click', function() {
            window._pdpOptionsPlacement();
            document.querySelectorAll(selector + ' > .label[aria-expanded]').forEach(function(label) {
                label.setAttribute('aria-expanded', String(label.parentElement.classList.contains('open')));
            });
        });
        // The theme scrolls an internal container; capture its scroll events too.
        document.addEventListener('scroll', window._pdpOptionsPlacement, true);
        window.addEventListener('resize', window._pdpOptionsPlacement, { passive: true });
        if (window.visualViewport) {
            window.visualViewport.addEventListener('resize', window._pdpOptionsPlacement, { passive: true });
            window.visualViewport.addEventListener('scroll', window._pdpOptionsPlacement, { passive: true });
        }
    }
})();
